export const TIME_BASED_RULE_TYPES = ['pasture'];
